import { InjectionToken, Inject, Injectable } from '@angular/core';

import { SecurityGroup } from './security.group';
import { OidcConfig } from '../open-idconnect/configuration/oidc-config.settings';

/**
 * Enumeration of all supported security models
 */
export enum SecurityImplementation {
  /**
   * Specifies that the application is using OpenID Connect protocols for security
   */
  Oidc = 'Oidc'
}

/**
 * The configuration for the security framework
 */
export interface SecurityConfig {
  /**
   * Specify which implementation should be used for security
   */
  implementation: SecurityImplementation;

  /**
   * The configuration settings for the chosen implementation (e.g. OidcConfig, SamlConfig, etc.)
   */
  // Design Note: When extending the framework this the configuration should be multiplexed (e.g. OidcConfig | SamlConfig | OAuthConfig)
  configuration: OidcConfig;

  /**
   * Defines the security white-list that authentication credentials should be sent to
   * [Note: This should list the API domains that you are attempting to use]
   */
  securityDomains: string[];

  /**
   * The role to group mappings which should be used
   */
  groups?: SecurityGroup[];
}

export const SecurityConfigInjectionToken = new InjectionToken<SecurityConfig>('SecurityConfig');

// We added this wrapper to allow the injection of the configuration within a factory
// as the @inject annotation is not usable in that scenario
@Injectable()
export class SecurityConfigWrapper {
  constructor(@Inject(SecurityConfigInjectionToken) public configuration: SecurityConfig) {
  }
}